<template>
	<v-card>
		<v-card-title class="justify-center flex-column">
			<div
				class="primary--text mb-3 font-weight-bold text-center"
				v-html="titolo"
			></div>
			<div>DICHIARO CHE:</div>
		</v-card-title>
		<v-card-text>
			<v-stepper
				v-model="stepAttuale"
				flat
			>
				<v-stepper-header
					style="box-shadow: none; border-bottom: none"
				>
					<template v-for="step in steps">
						<v-stepper-step
							:key="`${step}-step`"
							:complete="stepAttuale > step"
							:step="step"
						>
							<!--<span class="font-weight-medium">-->
							<!--	{{ step }}-->
							<!--</span>-->
						</v-stepper-step>
						
						<v-divider
							v-if="step !== steps.length"
							:key="step"
						></v-divider>
					</template>
				</v-stepper-header>
				
				<v-stepper-items>
					<v-stepper-content
						:key="`step-1-content`"
						:step="1"
					>
						<v-form ref="step1form">
							<v-row>
								<v-col>
									<v-checkbox
										v-model="a"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Utilizzo un computer con Javascript attivo e browser aggiornato (no Safari, no Dispositivi Aziendali, no Chromebook).
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-model="b"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Seguirò tutte le indicazioni dell’Allenatore Simone per migliorare i miei tempi di invio.
							        </span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
					
					<v-stepper-content
						:key="`step-2-content`"
						:step="2"
					>
						<v-form ref="step2form">
							<v-row>
								<v-col>
									<v-checkbox
										v-model="c"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Sono nel gruppo Telegram della squadra e seguo le comunicazioni del mio Coordinatore e del team ClickDay.it, attivando le notifiche e rispondendo ai messaggi tempestivamente, soprattutto nei giorni prima del Click Day.
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-if="accettazioneRegoleAlPrimoAccesso"
										v-model="d"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Supererò la selezione con almeno il 50% di vittorie nel Simulatore. Chiedo aiuto al Coordinatore se ho bisogno.
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-model="e"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Seguirò i passaggi della CheckList che riceverò su Telegram prima del Click Day.
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-model="f"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Quando mi sarà assegnata un’azienda, farò un Test di Accesso seguendo la procedura fornita dal Coordinatore.
							        </span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
					
					<v-stepper-content
						:key="`step-3-content`"
						:step="3"
					>
						<v-form ref="step3form">
							<v-row>
								<v-col>
									<v-checkbox
										v-model="g"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Il giorno del Click Day sarò in postazione almeno un'ora prima dell'orario di invio della domanda.
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-model="h"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Appena scatta l'orario di invio della domanda, invierò la domanda il più velocemente possibile.
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-model="i"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Subito dopo, farò uno screenshot di tutta la schermata completa con URL e orario visibili e lo invierò al Coordinatore su Telegram.
							        </span>
										</template>
									</v-checkbox>
									
									<v-checkbox
										v-model="j"
										:rules="[vincoli.checkboxRequired]"
									>
										<template v-slot:label>
							        <span>
							          Sono consapevole che senza l’invio dello screenshot finale della schermata completa di orario e url, non riceverò alcun pagamento o bonus (nè per selezione, nè per amici invitati), anche con un tempo vincente.
							        </span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
						</v-form>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				v-if="stepAttuale != 1"
				:color="scdColor"
				class="white--text"
				rounded
				@click="stepAttuale--"
				:disabled="accettazioneInCorso"
			>
				Indietro
			</v-btn>
			<v-btn
				v-if="stepAttuale != steps.length"
				rounded
				style="text-transform:none; color:white;"
				@click="gestisciAvanti"
				:color="scdOrange"
			>
				Avanti
			</v-btn>
			<v-btn
				v-if="stepAttuale == steps.length"
				rounded
				style="text-transform:none; color:white;"
				:color="scdOrange"
				@click="accetta()"
				:loading="accettazioneInCorso"
			>
				Accetto
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import mixin from '../mixins';

export default {
	props: [
		'infoCliccatore'
	],
	
	data() {
		return {
			stepAttuale: 1,
			steps: [1, 2, 3],
			
			a: false,
			b: false,
			c: false,
			d: false,
			e: false,
			f: false,
			g: false,
			h: false,
			i: false,
			j: false,
			
			accettazioneInCorso: false
		};
	},
	
	computed: {
		titolo() {
			if (this.accettazioneRegoleAlPrimoAccesso) {
				return 'ACCETTAZIONE PUNTI CHIAVE DEL CONTRATTO E DEL REGOLAMENTO'
			}
			else {
				return `COMPLIMENTI PER AVER SUPERATO LA SELEZIONE!<br>
				MANCA POCO AL CLICK DAY ASSICURATI DI ESSERE PRONTO!
				`
			}
		},
		accettazioneRegoleAlPrimoAccesso() {
			return this.infoCliccatore.conferma_lettura_regole === false
		}
	},
	
	methods: {
		gestisciAvanti() {
			if (!this.$refs[`step${this.stepAttuale}form`].validate()) return;
			this.stepAttuale++;
		},
		accetta() {
			if (!this.$refs[`step${this.stepAttuale}form`].validate()) return;
			
			this.accettazioneInCorso = true;
			
			let nome_colonna_db = null;
			if (this.accettazioneRegoleAlPrimoAccesso) nome_colonna_db = 'conferma_lettura_regole';
			else nome_colonna_db = 'conferma_lettura_regole_dopo_superamento_selezione';
			
			axios.post('/cliccatori/conferma-lettura-regole', {
				nome_colonna_db: nome_colonna_db
			})
				.then(() => {
					this.$emit('regole-accettate')
				})
				.finally(() => {
					this.accettazioneInCorso = false;
				})
		}
	}
	
};
</script>

<style lang="scss" scoped>

</style>